module.exports = __webpack_public_path__ + "static/media/ramka_modal.21e9c39d.png";